import { useTranslation } from 'react-i18next';
import { Channel } from 'stream-chat';

import { chatdate } from '@/utilities/dateUtils';

export default function CustomLastMessagePreview({ channel }: { channel: Channel }) {
  const { t, i18n } = useTranslation();

  const messages = channel.state.messages;
  if (!messages.length) {
    return '';
  }
  const lastMessage = channel.state.messages[channel.state.messages.length - 1];
  const createdAt = lastMessage.created_at;
  const createdTimeMicros = createdAt.getTime() * 1000;

  const updateTime = chatdate(createdTimeMicros, i18n.language, t);
  return (
    <>
      <span>{lastMessage.text?.replace('\\.', '.').replace('\\)', ')')}</span>
      {updateTime}
    </>
  );
}
